module.exports = __webpack_public_path__ + "static/media/icon--birthday-celebration.e0b16018.png";